import { StationeryTranslations } from '@locales/generated';

export type NumeralsTranslations = StationeryTranslations['numerals'];

// The first two digits could be "Two Thousand" or "Twenty", so leaving it freeform.
export function getTwoDigitsCardinalFromYear(year: number, tNumerals: NumeralsTranslations): string {
  if (year <= 2000 || year > 2099) return '';
  return tNumerals.cardinals[year - 2000]?.() ?? '';
}

// Example output: Four O'Clock
export function getOclock(date: Date, tNumerals: NumeralsTranslations): string {
  const hours12 = date.getHours() % 12;
  const totalMinutes = hours12 * 60 + date.getMinutes();
  const quarters = Math.round(totalMinutes / 15);
  return tNumerals.cardinalOclockQuarters[quarters]?.() ?? '';
}

export function getTimeOfDay(date: Date, tNumerals: NumeralsTranslations): string {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  if (hours === 0 && minutes === 0) return tNumerals.timeOfDay.midnight();
  if (hours === 12 && minutes === 0) return tNumerals.timeOfDay.noon();
  if (hours >= 0 && hours < 12) return tNumerals.timeOfDay.morning();
  if (hours >= 12 && hours < 18) return tNumerals.timeOfDay.afternoon();
  return tNumerals.timeOfDay.evening();
}
